export type PlanItemKind = "lesson" | "quiz";

export interface PlanItemCountable {
  itemKind?: PlanItemKind;
}

export type PlanItemCounts = {
  lessons: number;
  quizzes: number;
  total: number;
};

export function countPlanItems<T extends PlanItemCountable>(items: readonly T[]): PlanItemCounts {
  let lessons = 0;
  let quizzes = 0;
  for (const item of items) {
    if (item.itemKind === "quiz") quizzes += 1;
    else lessons += 1;
  }
  return { lessons, quizzes, total: lessons + quizzes };
}

export function formatPlanItemCounts(counts: PlanItemCounts): string {
  const parts: string[] = [];
  if (counts.lessons > 0) {
    parts.push(`${counts.lessons} lesson${counts.lessons === 1 ? "" : "s"}`);
  }
  if (counts.quizzes > 0) {
    parts.push(`${counts.quizzes} quiz${counts.quizzes === 1 ? "" : "es"}`);
  }
  if (parts.length === 0) return "0 assignments";
  return parts.join(", ");
}

export function assignmentColumnHeader(title: string, itemKind?: PlanItemKind): string {
  const kind = itemKind === "quiz" ? "Quiz" : "Lesson";
  return `${kind}: ${title}`;
}
